<template>
  <div>
    <div class="step-hd">
      <h2>账户设置</h2>
      <p>设置管理员账号与结算银行账户</p>
    </div>
    <div class="step-layout step-layout-2">
      <div class="col-stack">
        <div class="sw">
          <label class="sw-tgl">
            <input
              v-model="form.adminSameAsLegal"
              type="checkbox"
              :true-value="1"
              :false-value="0"
              @change="onSameChange"
            />
            <span class="sw-track" />
          </label>
          <div>
            <div class="sw-t">管理员与法人为同一人</div>
            <div class="sw-d">自动带入法人信息</div>
          </div>
        </div>
        <div class="card" :style="adminCardStyle">
          <div class="card-bd">
            <div class="sec-title">管理员身份证</div>
            <div class="sec-desc">上传人像面与国徽面</div>
            <div class="up-mini">
              <el-form :model="form">
                <ImgUpload
                  :upload-config="{ lebal: '管理员身份证人像面照片', prefix: 'contactsIdentification', form: form, suffix: 'Img' }"
                  :required="form.adminSameAsLegal !== 1"
                  @handleImgSuccess="contactsImgSuccess"
                />
              </el-form>
              <el-form :model="form">
                <ImgUpload
                  :upload-config="{ lebal: '管理员身份证国徽面照片', prefix: 'contactsIdentificationBack', form: form, suffix: 'Img' }"
                  :required="form.adminSameAsLegal !== 1"
                  @handleImgSuccess="contactsOcr"
                />
              </el-form>
            </div>
          </div>
        </div>
        <div class="hint hint-ok">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          >
            <path d="M12 22s8-3.6 8-10V5l-8-3-8 3v7c0 6.4 8 10 8 10z" />
            <path d="m9 11.5 2 2 4-4" />
          </svg>
          <span>管理员手机号默认使用登录手机号（{{ maskPhone(adminPhone) }}），自动带入，无需再次验证。</span>
        </div>
      </div>
      <div class="card">
        <div class="card-hd"><h3>管理员信息</h3></div>
        <div class="card-bd">
          <div class="g2">
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>姓名<span class="ocr-tag">OCR</span></label>
              <input v-model="form.userName" class="fld-in" placeholder="自动识别" />
            </div>
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>身份证号<span class="ocr-tag">OCR</span></label>
              <input v-model="form.contactsIdnum" class="fld-in mono" placeholder="自动识别" />
            </div>
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>身份证有效期<span class="ocr-tag">OCR</span></label>
              <input v-model="form.contactsIdnumValidity" class="fld-in mono" placeholder="自动识别或手动填写" />
            </div>
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>职务</label>
              <select v-model="form.adminPosition" class="fld-sel">
                <option>法定代表人 / 总经理</option>
                <option>物流负责人</option>
                <option>财务负责人</option>
                <option>业务经办人</option>
                <option>其他</option>
              </select>
            </div>
            <div class="fld">
              <label class="fld-lbl">邮箱 <span class="opt">选填</span></label>
              <input v-model="form.adminEmail" class="fld-in" placeholder="接收账单与报表" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" style="margin-top:24px">
      <div class="card-hd"><h3>结算账户</h3></div>
      <div class="card-bd">
        <div class="fld-hint" style="margin:-4px 0 16px">用于运费结算，账户户名默认与营业执照企业名称一致</div>
        <div class="step-layout" style="display:grid;grid-template-columns:1fr 300px;gap:24px;align-items:start">
          <div class="g2" style="margin-bottom:-24px">
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>开户行</label>
              <el-select v-model="form.bankNo" class="fld-sel" placeholder="请选择" clearable filterable @change="onBankChange">
                <el-option v-for="item in bankList" :key="item.code" :label="item.name" :value="item.code" />
              </el-select>
            </div>
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>开户支行</label>
              <el-select v-model="form.bankAssociationNumber" class="fld-sel" placeholder="请先选择开户行，再搜索支行" filterable remote clearable :disabled="!form.bankNo" :remote-method="queryBankBranches" :loading="branchLoading" @change="onBranchChange">
                <el-option v-for="item in branchList" :key="item.bankNo" :label="item.bankName" :value="item.bankNo" />
              </el-select>
            </div>
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>账号</label>
              <input v-model="form.bankAccount" class="fld-in mono" placeholder="请输入对公账户账号" />
            </div>
            <div class="fld">
              <label class="fld-lbl"><span class="req">*</span>开户行行号</label>
              <input v-model="form.bankAssociationNumber" class="fld-in mono" placeholder="选择开户支行后自动带入" readonly />
              <div class="fld-hint">大额支付系统行号，用于跨行转账</div>
            </div>
          </div>
          <div>
            <label class="fld-lbl">开户许可证 <span class="opt">选填</span></label>
            <el-form :model="form">
              <ImgUpload
                :upload-config="{ lebal: '开户许可证', prefix: 'bankLicense', form: form, suffix: 'Img' }"
                :required="false"
                @handleImgSuccess="onBankLicenseSuccess"
              />
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <div class="step-ft">
      <button type="button" class="btn step-btn-sec" @click="$emit('prev')">← 上一步</button>
      <div class="step-ft-right">
        <span v-if="nextError" class="step-err">{{ nextError }}</span>
        <button type="button" class="btn btn-pri step-btn" @click="next">下一步 →</button>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUpload from "@/components/ImgUpload";
import { getOcrInfo } from "@/api/shipment";
import { realDay, validateIDNumber, validateIdCardDueDate } from "@/utils/validate";
import { getBankDict } from "@/api/commonApi";
import { getPublicBankAssociationNumber } from "@/api/bankCard";

export default {
  name: "StepAccount",
  components: { ImgUpload },
  props: {
    value: { type: Object, required: true }
  },
  data() {
    return { nextError: "", bankList: [], branchList: [], branchLoading: false };
  },
  computed: {
    form: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); }
    },
    adminCardStyle() {
      if (this.form.adminSameAsLegal !== 1) return {};
      return { opacity: "0.4", pointerEvents: "none" };
    },
    adminPhone() {
      return this.form.phone || sessionStorage.getItem("shipperRegisterH5Phone") || "";
    }
  },
  created() {
    if (!this.form.phone) {
      const phone = sessionStorage.getItem("shipperRegisterH5Phone") || "";
      if (phone) this.$set(this.form, "phone", phone);
    }
    getBankDict()
      .then(response => {
        const list = (response.data || []).filter(item => item.type === "bank");
        this.bankList = list.length ? list[0].dictList : [];
      })
      .catch(() => {});
  },
  methods: {
    onBankChange(code) {
      const bank = this.bankList.find(item => item.code === code);
      this.$set(this.form, "bankName", bank ? bank.name : "");
      this.$set(this.form, "bankBranch", "");
      this.$set(this.form, "bankAssociationNumber", "");
      this.branchList = [];
    },
    async queryBankBranches(keyword) {
      if (!this.form.bankNo) return;
      this.branchLoading = true;
      try {
        const response = await getPublicBankAssociationNumber({
          bankCode: this.form.bankNo,
          bankName: keyword || "",
          pageNum: 1,
          pageSize: 50
        });
        this.branchList = (response.data && response.data.records) || [];
      } finally {
        this.branchLoading = false;
      }
    },
    onBranchChange(bankAssociationNumber) {
      const branch = this.branchList.find(item => item.bankNo === bankAssociationNumber);
      this.$set(this.form, "bankBranch", branch ? branch.bankName : "");
    },
    maskPhone(p) {
      if (!p || p.length < 7) return p || "";
      return p.slice(0, 3) + "****" + p.slice(-4);
    },
    openOcrLoading() {
      return this.$loading({ lock: true, text: "图片信息提取中", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.6)" });
    },
    onSameChange() {
      if (this.form.adminSameAsLegal === 1) this.syncFromLegal();
    },
    syncFromLegal() {
      this.$set(this.form, "userName", this.form.legalName || "");
      this.$set(this.form, "contactsIdnum", this.form.identificationNumber || "");
      this.$set(this.form, "contactsIdnumValidity", this.form.idCardDueDate || "");
      this.$set(this.form, "contactsIdentificationImg", this.form.identificationImg || "");
      this.$set(this.form, "contactsIdentificationBackImg", this.form.identificationBackImg || "");
    },
    async contactsImgSuccess(url) {
      const loading = this.openOcrLoading();
      try {
        const res = await getOcrInfo({ image: url, ocrType: "ocrIdidentityCardFront" });
        const data = (res && res.data) || {};
        if (!data.name && !data.identity) {
          throw new Error("身份证 OCR 未识别到有效信息，请重新上传清晰图片");
        }
        if (data.name) this.$set(this.form, "userName", data.name);
        if (data.identity) this.$set(this.form, "contactsIdnum", data.identity);
        this.$emit("saved");
      } catch (e) {
        this.$message.error((e && e.message) || "身份证人像面识别失败");
      } finally {
        loading.close();
      }
    },
    async contactsOcr(url) {
      const loading = this.openOcrLoading();
      try {
        const res = await getOcrInfo({ image: url, ocrType: "ocrIdidentityCardFrontBack" });
        const data = (res && res.data) || {};
        if (!data.expiryDate) {
          throw new Error("身份证有效期 OCR 未识别到，请重新上传清晰图片");
        }
        if (data.expiryDate == "长期" || data.expiryDate == "9999-12-31") {
          this.$set(this.form, "contactsIdnumValidity", "9999-12-31");
        } else if (data.expiryDate) {
          const time = String(data.expiryDate).replace(/[^\d]/g, "");
          if (realDay(time)) {
            this.$set(this.form, "contactsIdnumValidity", time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6));
          } else {
            this.$set(this.form, "contactsIdnumValidity", data.expiryDate);
          }
        }
        this.$emit("saved");
      } catch (e) {
        this.$message.error((e && e.message) || "身份证国徽面识别失败");
      } finally {
        loading.close();
      }
    },
    onBankLicenseSuccess() {
      this.$emit("saved");
    },
    next() {
      const f = this.form;
      const required = [
        ["bankName", "请选择开户行"],
        ["bankNo", "请选择开户行"],
        ["bankBranch", "请选择开户支行"],
        ["bankAccount", "请填写账号"],
        ["bankAssociationNumber", "请选择开户支行"]
      ];
      if (f.adminSameAsLegal !== 1) {
        required.push(
          ["userName", "请填写管理员姓名"],
          ["contactsIdnum", "请填写管理员身份证号"],
          ["contactsIdnumValidity", "请填写管理员身份证有效期"],
          ["contactsIdentificationImg", "请上传管理员身份证人像面"],
          ["contactsIdentificationBackImg", "请上传管理员身份证国徽面"]
        );
      }
      if (!f.adminPosition) required.push(["adminPosition", "请选择职务"]);
      if (!/^1\d{10}$/.test(f.phone || "")) {
        this.nextError = "管理员手机号异常，请重新登录";
        this.$message.warning(this.nextError);
        return;
      }
      for (const [k, msg] of required) {
        if (!f[k] || (typeof f[k] === "string" && !String(f[k]).trim())) {
          this.nextError = msg;
          this.$message({ type: "warning", message: msg, duration: 3000, offset: 60 });
          return;
        }
      }
      if (f.contactsIdnum && !validateIDNumber(f.contactsIdnum)) {
        this.nextError = "身份证号格式不正确，请检查后重新填写";
        this.$message.warning(this.nextError);
        return;
      }
      if (f.contactsIdnumValidity && !validateIdCardDueDate(f.contactsIdnumValidity)) {
        this.nextError = "身份证有效期格式不正确，请检查后重新填写";
        this.$message.warning(this.nextError);
        return;
      }
      this.nextError = "";
      this.$emit("next");
    }
  }
};
</script>
